import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { FullScreenLoader } from 'src/app/components';
import { handleNavigationFromNotifications } from '../notifications/notifications.helper';
import { switchCurrentChildIfNeeded } from 'src/app/utilities/helpers';
import { store, useAppDispatch, useAppSelector } from 'src/app/services/store';
import { getCurrentChild, getLoginData, logout } from 'src/shared/redux-state/src';
import { ChildrenStoreData, LoginStorageData } from 'src/shared/types/src';
import { AppRoutes } from 'src/app/navigation/routes';
import { usePreviousRoute } from 'src/app/guards/PreviousRouteContext';

const DeepLinkScreen = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { token } = useParams();
  const { clearPreviousRoute, emailSetter } = usePreviousRoute();

  const loginData: LoginStorageData = useAppSelector(getLoginData);
  const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

  useEffect(() => {
    if(token){
      const payload = JSON.parse(atob(token));

      if(payload?.eventType === 'ACCOUNT_ACTIVATION'){
        dispatch(logout({ reduxStore: store }));
        clearPreviousRoute();
        emailSetter(payload?.email || '')
        navigate(AppRoutes.MOBILE_APP_LANDSCAPE_VIEW);
        return;
      }
      
      (async () => {
        const canNavigate = await switchCurrentChildIfNeeded(payload, currentChild, loginData, dispatch);
        if (canNavigate && payload?.eventType) {
          const entityDetailsAsJSONString = payload?.entityDetails ? JSON.stringify(payload.entityDetails) : '';
          handleNavigationFromNotifications(navigate, payload.eventType, payload.entityId, entityDetailsAsJSONString);
        } else {
          navigate(AppRoutes.HOME);
        }
      })()
    }
  }, [])

  return (
    <div className='main-wrapper bg-white container '>
      <FullScreenLoader />
    </div>
  )
}

export default DeepLinkScreen;